import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { CommonService } from '@app/shared/services/common.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../modal/modal.component';
import { InternalNotesModalComponent } from '../internal-notes-modal/internal-notes-modal.component';
import { AssignmentSessionData, errorMessages, modalButtonTitles, ModalConfig, modalContent, modalHeading } from '../../constants/modal.model';
import { DxButtonModule, DxDataGridComponent, DxDataGridModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { HttpService } from '@core/services/http.service';
import { AlertService } from '@core/services/alert.service';
import { forkJoin, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { Router } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { ROLE_ID } from '@app/shared/constants/rolesConstant.model';
import {
  BOOLEAN_VALUES,
  CELL_TEMPLATES,
  DATA_FIELDS,
  DATA_GRID_CONSTANTS,
  DATE_FIELDS,
  GRID_OPTIONS,
  LOCK_STATUS_CODES,
  queues,
  SEARCH_CONFIG,
  APP_ID_ICON_GUIDANCE_FALLBACKS
} from '@app/shared/constants/queue.constants';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { DataGridVO } from './data-grid.model';
import { LocalService } from '@app/@core/services/local.service';
import { NumbersOnlyDirective } from '@app/shared/directives/numberOnly.directive';
import { patternMatch } from '@app/shared/constants/validators.model';
import { resolveStatusColor, resolveBgStatusColor } from '@app/shared/constants/status-color.constants';
import { SurrenderService } from '@app/surrender/surrender.service';
import { InAppMessageService } from '@app/pages/in-app-message/in-app-message.service';
import { TooltipModule } from 'primeng/tooltip';
@Component({
  selector: 'app-data-grid',
  standalone: true,
  imports: [CommonModule, DxDataGridModule,NumbersOnlyDirective, DxPopupModule, DxTemplateModule, DxButtonModule, MatTooltipModule, TooltipModule],
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    private lastViewportWidth: number = typeof window !== 'undefined' ? window.innerWidth : 0;
  isMobileView: boolean = typeof window !== 'undefined' ? window.innerWidth <= 767 : false;
  scrollingConfig: any = this.getScrollingConfig();
  @Input() pagedata: (any[] & { total?: number }) | { data?: any[]; total?: number; totalRecords?: number; total_records?: number; totalCount?: number; pageSize?: number; page_size?: number } | null = [];
  @Input() activeTab: string;
  @Input() statusDataField: string = DATA_FIELDS.CD_APPLICATION_STATUS;
  @Input() onCaseIdClick?: (applicationId: string, event?: Event,flow?:string) => void;
   /** Optional third arg is row data (e.g. person_id for lookup-search) */
  @Input() onEducatorNameClick?: (educatorName: string, event?: Event, rowData?: any) => void;
  @Input() onComplaintIdClick?: (complaintId: string, complaintStatus: string, complaintData: any, event?: Event) => void;
  @Input() wordWrapEnabled: boolean = true;
  @Input() onRowPrepared?: (e: any) => void;
  applicationData: any[] = [];
  headers: any[] = [];
  showFilterRow: boolean = true;
  showHeaderFilter: boolean = true;
  hoverTooltipId: string | null = null;
  rowDownloadDialogData: any = null;
  customModal: NgbModalRef;
  currentPage: number = 1;
  totalItems: number = 0;
  totalPages: number = 1;
  displayMode: string = DATA_GRID_CONSTANTS.DISPLAY_MODE;
  pageSizes: number[] = [10, 25, 50];
  applicationtypes: any[] = [];
  applicationStatus: any[] = [];
  tabs: string[] = [];
  staffMembers: any[] = [];
  personsByRole: any[] = [];
  private readonly placeholderRowFlag = '__isPlaceholderRow';
  private isGeneratingPDF = false;
  currentRoleId: any;
  currentPageSize: number = 10;
  isAdmin : boolean = false;
  private destroy$ = new Subject<void>();
  /** Sticky flag so a later config recreate without the icon props cannot wipe a true value. */
  showPaymentPendingIconFlag = false;
  @Input() config: DataGridVO = new DataGridVO();
  @Input() onApplicationClick?: (applicationId: string, event?: Event) => void;
  @Output() applicationClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() assign: EventEmitter<{ record: any; assign: boolean; selectedStaffMemberId?: any; personsByRole?: any }> =
    new EventEmitter<{ record: any; assign: boolean; selectedStaffMemberId?: any; personsByRole?: any }>();
  @Output() customAction: EventEmitter<{ action: string; data: any }> = new EventEmitter<{
    action: string;
    data: any;
  }>();
  @Output() pageChange = new EventEmitter<{ page: number; pageSize: number }>();
  @Output() filterChange = new EventEmitter<{column : any , value : any}>();
  @Output() unArchivalChange:EventEmitter<string> = new EventEmitter<string>();
      isViewMode: boolean = false;
  @Output() rowChanged = new EventEmitter<any>();
  @Input() submittedStatusValues: string[] = ["Submitted"];
  @Input() documentStatusBadgeMode = false;
  @Input() statusColorOverrides: Record<string, string> = {};
  @ViewChild('gridContainer', { static: false }) gridContainer!: ElementRef;
  @ViewChild(DxDataGridComponent) dataGrid!: DxDataGridComponent;
  @ViewChild('registrationTemplate', { static: false, read: ViewContainerRef }) registrationTemplate!: ViewContainerRef;
  @ContentChild('actionsTemplate') projectedActionsTemplate?: TemplateRef<any>;
  @Input() actionsTemplateRef?: TemplateRef<any>;
  applicationIdClickable: boolean = true;
  complaintIdClickable: boolean = false;
    suffixList: any;
    activeversionid : any;
    hasComplaintFormId:boolean = false;
    licensePathLookup: any[] = [];
    responsiveisMobileView: boolean = false;
  pageSize: any;
  totalRecords: any;
  queuedata:any;
  queueDataSource: any = null;
  unreadCountByApplicationId: Record<number, number> = {};
  private readonly dateTimeFields: string[] = ['date_sent'];

  constructor(
    private commonService: CommonService,
    private ngbService: NgbModal,
    private myAppService: MyApplicationsService,
    private router: Router,
    private loaderService: LoaderService,
    private httpService: HttpService,
    private alertService: AlertService,
    private sessionStorage: LocalService,
    private surrenderService: SurrenderService,
    private inAppMessageService: InAppMessageService
  ) {
    this.rowDownloadDialogData = null;
    this.initializeConfig();
    this.loadDropdownData();
  }
private async loadDropdownData() {
    forkJoin([
      this.httpService.get(API_ENDPOINTS.SUFFIX),
      this.httpService.get(API_ENDPOINTS.APPLICATION_TYPES_LOOKUP),
      this.httpService.get(API_ENDPOINTS.LOOKUP_LICENSE_PATH)
    ]).subscribe({
      next: (item: any) => {
        this.suffixList = item[0].data;
        const noneIndex = this.suffixList.findIndex(item => item.value === 'None');
        if (noneIndex !== -1) {
          const noneItem = this.suffixList.splice(noneIndex, 1)[0];
          this.suffixList.push(noneItem);
        }
        this.applicationtypes = item[1].data || [];
        this.licensePathLookup = item[2]?.data || [];
      }

    });
  }
  private initializeConfig(): void {
    if (!this.config || !this.config.isValid()) {
      this.config = DataGridVO.create({
        role: this.config?.role || '',
        activeTab: this.config?.activeTab || '',
        showPaymentPendingIcon: this.config?.showPaymentPendingIcon || this.showPaymentPendingIconFlag,
        showPaymentCompletedIcon: this.config?.showPaymentCompletedIcon,
        showNewDocumentIcon: this.config?.showNewDocumentIcon,
        showNewUploadIcon: this.config?.showNewUploadIcon,
        showStaffUpdateIcon: this.config?.showStaffUpdateIcon
      });
    }
    this.syncPaymentPendingIconFlag();
  }

  private syncPaymentPendingIconFlag(): void {
    // Once enabled for this grid instance, keep it on so empty recreates cannot override it.
    if (this.config?.showPaymentPendingIcon) {
      this.showPaymentPendingIconFlag = true;
    }
  }
  private getLicensePathLabel(licensePathKey: any): string {
    if (!licensePathKey) return '';
    const keyStr = String(licensePathKey);
    if (this.licensePathLookup?.length > 0) {
      const foundItem = this.licensePathLookup.find(item => String(item.key) === keyStr);
      if (foundItem) return foundItem.value;
    }
    return keyStr;
  }

  onEditorPrepared(e: any) {
    if (this.isDateField(e.dataField) || e.dataField && this.config?.customHeaders?.some((h: any) => h?.dataField === e.dataField && (h?.dataType === 'date' || h?.allowSearch?.type === 'date'))) {
      e.editorName = 'dxDateBox';
      e.editorOptions.format = 'MM/dd/yyyy';
      e.editorOptions.mask = '99/99/9999';
      const editor = e.editorElement;

      const maxDate = new Date(9999, 11, 31);
      const pad = (n: number) => n.toString().padStart(2, '0');
      const maxDateStr = `${pad(maxDate.getMonth() + 1)}/${pad(maxDate.getDate())}/${maxDate.getFullYear()}`;
      let errorMsgElem = document.createElement('div');
      errorMsgElem.className = 'date-error-message';
      errorMsgElem.style.display = 'none';
      document.body.appendChild(errorMsgElem);

      const showErrorMsg = (msg: string) => {
        const rect = editor.getBoundingClientRect();
        errorMsgElem.textContent = msg;
        errorMsgElem.style.left = `${rect.left + window.scrollX}px`;
        errorMsgElem.style.top = `${rect.bottom + window.scrollY + 2}px`;
        errorMsgElem.style.display = 'block';
      };
      const hideErrorMsg = () => {
        errorMsgElem.style.display = 'none';
      };

      editor.addEventListener('input', (event: any) => {
        let value = event.target.value;
        value = value.replace(patternMatch.number, '');
        hideErrorMsg();
        if (value.length > 2 && value.charAt(2) !== '/') {
          value = value.slice(0, 2) + '/' + value.slice(2);
        }
        if (value.length > 5 && value.charAt(5) !== '/') {
          value = value.slice(0, 5) + '/' + value.slice(5);
        }
        if (value.length > 10) {
          value = value.slice(0, 10);
        }
        if (value.length === 10) {
          const [mm, dd, yyyy] = value.split('/');
          const month = Number(mm);
          const day = Number(dd);
          const year = Number(yyyy);
          let isValid = true;
          if (
            isNaN(month) || isNaN(day) || isNaN(year) ||
            month < 1 || month > 12 ||
            day < 1 || day > 31 ||
            year < 1 || year > 9999
          ) {
            isValid = false;
          } else {
            const testDate = new Date(year, month - 1, day);
            if (
              testDate.getFullYear() !== year ||
              testDate.getMonth() !== month - 1 ||
              testDate.getDate() !== day
            ) {
              isValid = false;
            }
          }
          if (!isValid) {
            value = maxDateStr;
            showErrorMsg(errorMessages.invalidDate);
          } else {
            const enteredDate = new Date(year, month - 1, day);
            if (enteredDate > maxDate) {
              value = maxDateStr;
              showErrorMsg(errorMessages.dateExceed);
            }
          }
        }
        event.target.value = value;
      });
    }
  }
  recalculatePagerInfo() {
    const actualLength = this.getActualRowCount();
    if (actualLength > 0) {
      this.totalItems = actualLength;
      this.totalPages = Math.ceil(this.totalItems / this.currentPageSize);
    } else {
      this.totalItems = 0;
      this.totalPages = 1;
    }
    // Only reset currentPage if we don't have server data source (i.e., not using server-side paging)
    // if (!this.queueDataSource) {
    //   this.currentPage = 1;
    // }
    this.getCustomInfoText();
  }

  /**
   * Some roles only allow application-id links on specific queue tabs. Lookup/educator grids pass
   * `onApplicationClick` with no queue `activeTab` — keep links clickable (otherwise a plain span is shown).
   */
  private applyApplicationIdClickPolicy(): void {
    this.complaintIdClickable = false;
    const userObj = this.commonService.getCurrentUserData();
    if (!userObj?.userroles?.[0]?.id) {
      this.applicationIdClickable = true;
      return;
    }
    this.currentRoleId = userObj.userroles[0].id;
    const userRoleId = Number(this.currentRoleId);

    if (
      (userRoleId === ROLE_ID.Licensing_LeadTechnician || userRoleId === ROLE_ID.Licensing_Technician) &&
      !(this.activeTab === queues[3] || this.activeTab === queues[4])
    ) {
      this.applicationIdClickable = false;
    } else if (
      (userRoleId === ROLE_ID.Chief_Compliance_Investigator || userRoleId === ROLE_ID.Compliance_Investigator) &&
      !(this.activeTab === queues[5])
    ) {
      this.applicationIdClickable = false;
    } else {
      this.applicationIdClickable = true;
    }

    if (
      (userRoleId === ROLE_ID.Chief_Compliance_Investigator || userRoleId === ROLE_ID.Compliance_Investigator) &&
      this.activeTab === queues[5]
    ) {
      this.complaintIdClickable = true;
    }

    // if (this.onApplicationClick) {
    //   this.applicationIdClickable = true;
    // }
    if(userRoleId === ROLE_ID.NDE_Administrator){
      this.isAdmin = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.syncPaymentPendingIconFlag();
      if (this.showPaymentPendingIconFlag) {
        console.log('[DataGrid] payment icon config', {
          showPaymentPendingIcon: this.config?.showPaymentPendingIcon,
          showPaymentPendingIconFlag: this.showPaymentPendingIconFlag,
          role: this.config?.role,
          activeTab: this.config?.activeTab,
          rows: (this.config?.data || []).map((r: any) => ({
            application_id: r?.application_id,
            additional_endorsements: r?.additional_endorsements,
            veteran_status_payment_required: r?.veteran_status_payment_required
          }))
        });
      }
    }

    if (changes['pagedata'] && changes['pagedata'].currentValue) {
      const data = this.extractArrayFromPagedData(changes['pagedata'].currentValue);

      if (data.length) {
        this.loadUnreadMessageCount(data);
      }
    }

    if (changes['role'] || changes['config']) {
      this.getData();
    }

    if (changes['data'] || (changes['config'] && this.config?.data) || changes['config']) {
      const currentData = this.config.data;
      if (Array.isArray(currentData)) {
        const normalizedRows = currentData.map(row => {
          const copy: any = Object.assign({}, row);
          if (copy[DATA_FIELDS.APPLICATION_ID] !== undefined && copy[DATA_FIELDS.APPLICATION_ID] !== null) {
            copy[DATA_FIELDS.APPLICATION_ID] = String(copy[DATA_FIELDS.APPLICATION_ID]);
          }
          return this.convertDateFields(copy);
        });
        this.applicationData = this.applyPlaceholderRows(normalizedRows);
      } else {
        this.applicationData = this.applyPlaceholderRows([]);
      }
      this.recalculatePagerInfo();
      const hasRows = this.hasData();
      this.showFilterRow = hasRows;
      this.showHeaderFilter = hasRows;

      if (this.config && this.config.initialFilters && Array.isArray(this.config.initialFilters) && this.config.initialFilters.length > 0) {
        setTimeout(() => {
          try {
            if (this.dataGrid && this.dataGrid.instance) {
              this.dataGrid.instance.clearFilter();
              this.config.initialFilters.forEach((filter: any) => {
              const f = filter;
              if (Array.isArray(f) && f.length === 3 && typeof f[0] === 'string') {
                const field = f[0];
                const val = f[2];
                try {
                  this.dataGrid.instance.columnOption(field, 'filterValues', val);
                  if(this.config.visibleColumns[field] == false){
                    f[0] = f[0];
                    f[1] = f[1];
                    f[2] = f[2][0];
                    this.dataGrid.instance.filter(f);
                  }
                } catch (innerErr) {
                  // ignore if columnOption not available or fails
                }
              } else {
                try {
                  this.dataGrid.instance.filter(f);
                } catch (innerErr) {
                  // ignore
                }
              }
            });
            }
          } catch (err) {
            console.error('Failed to apply initial filters to DataGrid', err);
          }
        }, 0);
      }
    }
    const userObj = this.commonService.getCurrentUserData();
    if (!userObj) return;
    this.applyApplicationIdClickPolicy();
  }

  ngOnInit(): void {
    console.log('DataGridComponent initialized with config:', this.config.data);
  this.loadPersonsByRole();
  const userObj = this.commonService.getCurrentUserData();
    if (!userObj) return;
    this.applyApplicationIdClickPolicy();
    if (this.config && this.config.initialFilters && Array.isArray(this.config.initialFilters) && this.config.initialFilters.length > 0) {
        setTimeout(() => {
          try {
            if (this.dataGrid && this.dataGrid.instance) {
              const f = this.config.initialFilters;
              if (Array.isArray(f) && f.length === 3 && typeof f[0] === 'string') {
                const field = f[0];
                const val = f[2];
                try {
                  // this.dataGrid.instance.columnOption(field, 'filterValues', [val]);
                  this.dataGrid.instance.filter(f);
                } catch (innerErr) {
                  // ignore if columnOption not available or fails
                }
              } else {
                try {
                  this.dataGrid.instance.filter(f);
                } catch (innerErr) {
                  // ignore
                }
              }
            }
          } catch (err) {
            console.error('Failed to apply initial filters to DataGrid', err);
          }
        }, 0);
      }
      this.hasComplaintFormId = this.config.customHeaders.some(
        col => col.dataField === 'complaint_form_id'
      );
     sessionStorage.removeItem('userapplicationmode');
  }

  ngAfterViewInit(): void {
    const removeHeaderColumnLines = () => {
      if (this.gridContainer && this.gridContainer.nativeElement) {
        const headerRows = this.gridContainer.nativeElement.getElementsByClassName('dx-header-row');
        for (const row of headerRows) {
          row.classList.remove('dx-column-lines');
        }
      }
    };
    setTimeout(removeHeaderColumnLines, 0);

    const observer = new MutationObserver(() => {
      removeHeaderColumnLines();
    });
    observer.observe(this.gridContainer.nativeElement, {
      childList: true,
      subtree: true
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
      const nextViewportWidth = window.innerWidth;
    const widthChanged = Math.abs(nextViewportWidth - this.lastViewportWidth) > 1;

    // Ignore soft-keyboard resize events on mobile (height-only changes) to prevent input blur.
    if (!widthChanged) {
      return;
    }

    this.lastViewportWidth = nextViewportWidth;
        const activeElement = document.activeElement as HTMLElement | null;
    if (
      activeElement &&
      (activeElement.closest('.dx-header-filter-menu') ||
        activeElement.closest('.dx-datagrid-header-filter-menu') ||
        activeElement.closest('.dx-list-search'))
    ) {
      return;
    }
    this.isMobileView = window.innerWidth <= 767;
    this.scrollingConfig = this.getScrollingConfig();
  }

  private getScrollingConfig(): any {
    return {
      mode: 'standard',
      showScrollbar: this.isMobileView ? 'always' : 'onHover',
      useNative: true,
      scrollByContent: true,
      scrollByThumb: true
    };
  }

  isDateField(fieldName: string): boolean {
    return DATE_FIELDS.includes(fieldName as any);
  }

isDateTimeField(fieldName: string): boolean {
  return this.dateTimeFields.includes(fieldName);
}

  convertDateFields(row: any): any {
    const copy = { ...row };
    DATE_FIELDS.forEach(fieldName => {
      const value = copy[fieldName];
      if (value && value !== '---' && typeof value === 'string') {
        let date: Date | null = null;

        date = new Date(value);

        if (isNaN(date.getTime())) {
          const parts = value.split('/');
          if (parts.length === 3) {
            const month = parseInt(parts[0], 10);
            const day = parseInt(parts[1], 10);
            const year = parseInt(parts[2], 10);
            date = new Date(year, month - 1, day);
          }
        }

        if (date && !isNaN(date.getTime())) {
          copy[fieldName] = date;
        } else {
          copy[fieldName] = null;
        }
      } else if (value === '---' || value === '' || value === null || value === undefined) {
        copy[fieldName] = null;
      }
    });
    return copy;
  }

  hasData(): boolean {
    const currentData =
      this.data && this.data.length > 0
        ? this.data
        : this.applicationData && this.applicationData.length
          ? this.applicationData
          : [];
    return currentData.some(row => !this.isPlaceholderRow(row));
  }

  private applyPlaceholderRows(data: any[]): any[] {
    const normalizedRows = Array.isArray(data) ? data : [];
    const shouldFill = !!this.config?.fillEmptyRows;
    const minimumRows = this.config?.minVisibleRows || 0;

    if (!shouldFill || minimumRows <= 0) {
      return normalizedRows;
    }

    const actualRows = normalizedRows.filter(row => !this.isPlaceholderRow(row));
    const rowsNeeded = minimumRows - actualRows.length;

    if (rowsNeeded <= 0) {
      return actualRows;
    }

    const headerDefinitions = this.getHeaderDefinitionsForPadding(actualRows);
    if (!headerDefinitions.length) {
      return actualRows;
    }

    const placeholderRows = Array.from({ length: rowsNeeded }, () => this.createPlaceholderRow(headerDefinitions));
    return [...actualRows, ...placeholderRows];
  }

  private getHeaderDefinitionsForPadding(rows: any[]): any[] {
    if (this.config?.customHeaders && this.config.customHeaders.length > 0) {
      return this.config.customHeaders;
    }
    if (this.headers && this.headers.length > 0) {
      return this.headers;
    }
    if (rows && rows.length > 0) {
      const firstRow = rows[0];
      return Object.keys(firstRow || {}).map(key => ({ dataField: key }));
    }
    return [];
  }

  private createPlaceholderRow(headers: any[]): any {
    const placeholder: any = { [this.placeholderRowFlag]: true };
    headers.forEach(header => this.assignEmptyValue(placeholder, header?.dataField));
    return placeholder;
  }

  private assignEmptyValue(target: any, dataField?: string): void {
    if (!dataField) {
      return;
    }

    if (!dataField.includes('.')) {
      target[dataField] = '';
      return;
    }

    const segments = dataField.split('.');
    let cursor = target;
    for (let i = 0; i < segments.length - 1; i++) {
      const segment = segments[i];
      if (!cursor[segment] || typeof cursor[segment] !== 'object') {
        cursor[segment] = {};
      }
      cursor = cursor[segment];
    }
    cursor[segments[segments.length - 1]] = '';
  }

  private isPlaceholderRow(row: any): boolean {
    return !!row && row[this.placeholderRowFlag] === true;
  }

  private getActualRowCount(rows?: any[]): number {
    const source = Array.isArray(rows)
      ? rows
      : Array.isArray(this.applicationData)
        ? this.applicationData
        : [];
    return source.filter(row => !this.isPlaceholderRow(row)).length;
  }

  onGridOptionChanged(e: any) {
    if (e.name === GRID_OPTIONS.COLUMNS && e.fullName.includes(GRID_OPTIONS.VISIBLE) && e.component) {
      e.component.updateDimensions();
      e.component.repaint();
      this.recalculateFilteredPagerInfo(e.component);
    }

    // if (!this.queueDataSource || !e?.component) {
    //   return;
    // }

    // if (e.fullName === 'paging.pageIndex' && e.value !== e.previousValue) {
    //   this.emitServerPageChange(e.component.pageIndex() + 1, e.component.pageSize());
    // }

    // if (e.fullName === 'paging.pageSize' && e.value !== e.previousValue) {
    //   const page = e.component.pageIndex() + 1;
    //   this.emitServerPageChange(page, e.component.pageSize());
    // }
    if (e.fullName?.includes('columns') && e.fullName?.includes('filterValue')) {
        const match = e.fullName.match(/columns\[(\d+)\]/);
        const index = match ? +match[1] : null;

        if (index !== null) {
          const column = e.component.option('columns')[index];
          this.filterChange.emit({column : column.dataField , value : e.value});
          console.log('Column:', column.dataField);
          console.log('Value:', e.value);
        }
    }
  }

  private emitServerPageChange(page: number, pageSize: number): void {
    const safePage = Number(page) > 0 ? Number(page) : 1;
    const safePageSize = Number(pageSize) > 0 ? Number(pageSize) : (this.currentPageSize || 10);
    this.currentPage = safePage;
    this.currentPageSize = safePageSize;
    this.pageChange.emit({ page: safePage, pageSize: safePageSize });
  }

  recalculateFilteredPagerInfo(e: any) {
    const visibleRows = e.getVisibleRows ? e.getVisibleRows() : [];
    const normalizedRows = Array.isArray(visibleRows)
      ? visibleRows.map((row: any) => (row && row.data ? row.data : row))
      : [];
    const actualCount = this.getActualRowCount(normalizedRows);

    if (actualCount > 0) {
      this.totalItems = actualCount;
      this.totalPages = Math.ceil(this.totalItems / this.currentPageSize);
    } else {
      this.totalItems = 0;
      this.totalPages = 1;
    }
    // Only reset currentPage if we don't have server data source (i.e., not using server-side paging)
    // if (!this.queueDataSource) {
    //   this.currentPage = 1;
    // }
    this.getCustomInfoText();

  }

  onPageChanged(e: any) {
    this.currentPage = e.component.pageIndex() + 1;
    this.totalItems = e.component.totalCount();
    this.totalPages = Math.ceil(this.totalItems / e.component.pageSize());
    this.currentPageSize = e.component.pageSize();
    this.getCustomInfoText();
  }


  getCustomInfoText(): string {
    const hasQueueData = Array.isArray(this.queuedata);

    let totalItems: number;
    let totalPages: number;
    let currentPage: number;

    if (hasQueueData) {
      totalItems = Number(this.totalRecords ?? 0);
      const effectivePageSize = Number(this.pageSize || this.currentPageSize || this.customPageSize || 10);
      totalPages = totalItems > 0 ? Math.ceil(totalItems / effectivePageSize) : 1;
      currentPage = this.currentPage || 1;
    } else {
      totalItems = Number(this.totalItems || 0);
      totalPages = Number(this.totalPages || 1);
      currentPage = this.currentPage || 1;
    }

    if (totalItems === 0) {
      return `Page 1 of 1 (0 items)`;
    } else if (totalItems === 1) {
      return `Page ${currentPage} of ${totalPages} (1 item)`;
    } else {
      return `Page ${currentPage} of ${totalPages} (${totalItems} items)`;
    }
  }
  getData() {
    this.commonService
      .getQueuesData(this.role)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.headers = Array.isArray(data)
          ? data.map((h: any) => {
            if (h && h.dataField === DATA_FIELDS.APPLICATION_ID) {
              h.dataField = DATA_FIELDS.APPLICATION_ID;
            }
            if (h && h.dataField === DATA_FIELDS.APPLICATION_ID) {
              if (!h.allowSearch) {
                h.allowSearch = { isSearchEnable: SEARCH_CONFIG.IS_SEARCH_ENABLE, type: SEARCH_CONFIG.TYPE_STRING };
              } else {
                h.allowSearch.isSearchEnable = SEARCH_CONFIG.IS_SEARCH_ENABLE;
                if (!h.allowSearch.type) h.allowSearch.type = SEARCH_CONFIG.TYPE_STRING;
              }
            }
            // return {
            //   data: h,
            //   totalCount: Number(this.pagedata.total),
            // };
          })
          : data;
      });
  }

  getApplicationTypeDisplayValue(key: string): string {
    if (!this.applicationtypes || !key) {
      return key || '';
    }

    const appType = this.applicationtypes.find(type => type.key === key);
    return appType ? appType.value : key;
  }

  getApplicationStatusDisplayValue(key: string): string {
    if (!this.applicationStatus || !key) {
      return key || '';
    }

    const appStatus = this.applicationStatus.find(status => status.key === key);
    return appStatus ? appStatus.value : key;
  }

  getDocumentStatusBadgeClass(status: string): string {
    const normalized = String(status ?? '').trim().toLowerCase();
    const pendingStatuses = ['pending review'];
    const verifiedStatuses = ['verified', 'validated', 'valid', 'uploaded'];
    if (normalized === 'case') return 'case-status';
    const deficientStatuses = ['deficient'];
    const archivedStatuses = ['archived', 'replaced'];

    if (pendingStatuses.includes(normalized)) {
      return 'pending-review';
    }
    if (verifiedStatuses.includes(normalized)) {
      return 'verified';
    }
    if (deficientStatuses.includes(normalized)) {
      return 'deficient';
    }
    if (archivedStatuses.includes(normalized)) {
      return 'archived';
    }
    return '';
  }

  calculateStatusCellValue = (rowData: any) => this.getApplicationStatusDisplayValue(rowData.application_status || rowData.complaint_status);

  /** Same exclusions as viewApplication banner License Path (do not append path for these types). */
  private readonly licensePathExcludedApplicationTypes = ['Resolve', 'Surrender', 'Name Change', 'License Extension'];

  getApplicationTypeCellDisplayValue(rowData: any): string {
    const base = this.getApplicationTypeDisplayValue(rowData?.application_type);
    const rawType = rowData?.application_type;
    const rawStr = rawType == null ? '' : String(rawType).trim();
    const pathRaw = rowData?.license_path;
    const pathStr = pathRaw == null ? '' : String(pathRaw).trim();
    if (!pathStr || pathStr === '---') {
      return base;
    }
    if (
      this.licensePathExcludedApplicationTypes.includes(base) ||
      this.licensePathExcludedApplicationTypes.includes(rawStr)
    ) {
      return base;
    }
    const pathLabel = String(this.getLicensePathLabel(pathRaw) ?? '').trim();
    if (!pathLabel) {
      return base;
    }
    return `${base} \u2013 ${pathLabel}`;
  }

  calculateTypeCellValue = (rowData: any) => this.getApplicationTypeCellDisplayValue(rowData);

  calculateLockedByCellValue = (rowData: any) => {
     const lockStatus = String(rowData?.lockstatus || '').toUpperCase();
    if (lockStatus !== 'LOCKED' && lockStatus !== 'TEMP_LOCK') {
      return '---';
    }

    const value = rowData.locked_by;
    if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
      return '---';
    }
    return value;
  };

  calculateArchivalDateCellValue = (rowData: any) => {
    const value = rowData.archival_date;
    if (value === null || value === undefined || value === '' || value === '---') {
      return null;
    }
    return value;
  };

  hasNewDocument(rowData: any): boolean {
    const tab = rowData?._iconTab != null ? rowData._iconTab : this.activeTab;
    if (tab === 'default') {
      return false;
    }
    if (tab !== queues[2] && tab !== queues[4]) {
      return false;
    }
    return !!rowData?.new_document;
  }

  // hasStaffUpdateApplication(rowData: any): boolean {
  //   return !!rowData?.is_staff_update_application;
  // }

  hasStaffUpdate(rowData: any): boolean {
    return !!rowData?.is_staff_update;
  }

  hasNewUpdate(rowData: any): boolean {
    const tab = rowData?._iconTab != null ? rowData._iconTab : this.activeTab;
    if (tab === 'default') {
      return false;
    }
    // Mirrors queues: intake -> resubmitted signal; deficiency -> flag; DNQ -> new_update
    if (tab === queues[3]) {
      const r = rowData?.re_submitted_date ?? rowData?.resubmitted_date;
      return !!(r && r !== '---' && String(r).trim() !== '');
    }
    if (tab === queues[4]) {
      return !!rowData?.deficiency_addressed;
    }
    if (tab === queues[2]) {
      return !!rowData?.new_update;
    }
    return !!rowData?.new_update;
  }

  /**
   * Check if applicant update icon should show
   * Requires: new_update/deficiency_addressed conditions AND is_staff_update_application flag
   */
  shouldShowApplicantUpdateIcon(rowData: any): boolean {
    return this.hasNewUpdate(rowData) && !!rowData?.is_staff_update_application;
  }

  /**
   * Check if payment completed icon should show
   * Show ONLY when at least one parameter is explicitly FALSE and neither is TRUE
   * Cases:
   * - FALSE & FALSE → Show
   * - FALSE & NULL → Show
   * - NULL & FALSE → Show
   * - TRUE & FALSE → Hide
   * - FALSE & TRUE → Hide
   * - TRUE & TRUE → Hide
   * - NULL & NULL → Hide
   */
  hasPaymentCompleted(rowData: any): boolean {
    const veteran = rowData?.veteran_status_payment_required;
    const endorsements = rowData?.additional_endorsements;

    // At least one must be explicitly false
    const hasAtLeastOneFalse = veteran === false || endorsements === false;

    // Neither can be true
    const neitherIsTrue = veteran !== true && endorsements !== true;

    return hasAtLeastOneFalse && neitherIsTrue;
  }

  hasPaymentPending(rowData: any): boolean {
    // Only show payment pending icon when payment_pending field is explicitly true
    // This field is calculated in the dashboard with both status code AND payment flags
    return rowData?.payment_pending === true;
  }

  /** CMS GENERIC MESSAGES (G0029, G0030, G0032, G0086) with English fallbacks */
  appIdTooltip(code: 'G0029' | 'G0030' | 'G0032' | 'G0086'): string {
    const raw = this.config?.guidanceTooltips?.[code];
    if (raw != null && String(raw).trim() !== '') {
      return String(raw).trim();
    }
    return APP_ID_ICON_GUIDANCE_FALLBACKS[code];
  }

  customizeDateText = (cellInfo: any) => {
    const value = cellInfo.value;
    if (value === null || value === undefined || value === '' || value === '---') {
      return '---';
    }
    return cellInfo.valueText || cellInfo.value;
  };

  toggleTooltip(index: number, type: string, event?: MouseEvent) {
    if (this.hoverTooltipId === index + '-' + type) {
      this.hoverTooltipId = null;
    } else {
      this.hoverTooltipId = index + '-' + type;
    }
    if (event) {
      event.stopPropagation();
    }
  }

  toggleTooltipWithClick(index: number, type: string, tooltipRef: any, event?: MouseEvent) {
    const tooltipId = index + '-' + type;

    if (this.hoverTooltipId === tooltipId) {
      this.hoverTooltipId = null;
      tooltipRef.hide();
    } else {
      this.hoverTooltipId = tooltipId;
      tooltipRef.show();
    }

    if (event) {
      event.stopPropagation();
    }
  }
  loadPageData() {
    const payload = this.pagedata;

    if (!payload) {
      this.queuedata = [];
      this.totalRecords = 0;
      // this.queueDataSource = null;
      return;
    }

    if (Array.isArray(payload)) {
      this.queuedata = payload;
      this.totalRecords = payload.total ?? payload.length;
      this.pageSize = this.pageSize || this.currentPageSize || this.customPageSize || 10;
      // this.refreshQueueDataSource();
      return;
    }

    this.queuedata = Array.isArray(payload?.data) ? payload.data : [];
    this.totalRecords = payload?.total ?? payload?.totalRecords ?? payload?.total_records ?? payload?.totalCount ?? (Array.isArray(this.queuedata) ? this.queuedata.length : 0);
    this.pageSize = payload?.pageSize ?? payload?.page_size ?? this.pageSize ?? this.customPageSize ?? 10;
    this.currentPageSize = this.pageSize || this.currentPageSize;
    this.loadUnreadMessageCount(this.queuedata);
    // this.refreshQueueDataSource();
  }

  // private refreshQueueDataSource(): void {
  //   if (!Array.isArray(this.queuedata)) {
  //     this.queueDataSource = null;
  //     return;
  //   }

  //   const rows = this.queuedata;
  //   const totalCount = Number(this.totalRecords ?? rows.length);
  //   const resolvedPageSize = Number(this.pageSize || this.currentPageSize || this.customPageSize || 10);

  //   this.currentPageSize = resolvedPageSize;
  //   this.queueDataSource = new CustomStore({
  //     load: (_opts: any) => Promise.resolve(rows),
  //     totalCount: (_opts: any) => Promise.resolve(totalCount)
  //   });
  // }

  // get customInfoText(): string {
  //   return this.getCustomInfoText();
  // }
  private loadPersonsByRole() {
    this.httpService
      .get(API_ENDPOINTS.PERSONS_BY_ROLE)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response && response.data.data && Array.isArray(response.data.data)) {
            const personsWithFullNames = response.data.data.map((person: any) => ({
              ...person,
              full_name: person.full_name || `${person.first_name || ''} ${person.last_name || ''}`.trim()
            }));
            this.personsByRole = personsWithFullNames;
          }
        },
        error: _error => {
          this.personsByRole = [];
          this.alertService.error(errorMessages.failedPersons);
        }
      });
  }

  toggleRowDownloadDialog(data: any, event?: MouseEvent) {
    // Only show the inverted arrow for the clicked row
    if (this.rowDownloadDialogData && this.rowDownloadDialogData.application_id === data.application_id) {
      this.rowDownloadDialogData = null;
    } else {
      if (data && data.application_id) {
        this.rowDownloadDialogData = data;
      } else {
        this.rowDownloadDialogData = null;
      }
    }
    if (event) {
      event.stopPropagation();
    }
  }

  /**
   * Navigate to in-app messaging for the given row data.
   * Passes only the record id (rowData.id) to the route; no application_id fallback.
   */
  openInAppMessaging(rowData: any): void {
    const id = rowData?.id;
    if (id == null || id === '') {
      return;
    }
    this.router.navigate(['/pages/in-app-message', id]);
  }
  getSurrenderActivationId() {
    this.surrenderService.getSurrenderActivationId().pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response && response.status === 'success') {
          this.sessionStorage.setItem('surrenderActiveversionid', response.data?.data[0]?.activeversionid);
        }
      },
      error: (error) => {
        console.error('Error getting surrender activation id:', error);
      }
    });
  }

  private getApplicationCloseSessionTargets(): {
    backToHome: { name: string };
    backToGridPage: { name: string };
  } {
    const tab = (this.config.activeTab || this.config.role || '').trim();
    if (tab === 'lookup-search') {
      return {
        backToHome: { name: '/pages/lookup-search' },
        backToGridPage: { name: '/lookup-search' }
      };
    }
    const isDashboardAdminTab = tab.toLowerCase() === 'dashboardadmin';
    const queueSegment = isDashboardAdminTab ? 'dashboardadmin' : tab;
    const isQueueContext = queues.includes(tab as (typeof queues)[number]) || isDashboardAdminTab;
    if (isQueueContext) {
      return {
        backToHome: { name: `/pages/queues/${queueSegment}` },
        backToGridPage: { name: `/queues/${queueSegment}` }
      };
    }
    return {
      backToHome: { name: '/pages/my-app' },
      backToGridPage: { name: '/my-app' }
    };
  }

  viewApplication(event: Event) {
    this.getSurrenderActivationId();
    let selectedApp = null;
    if (typeof event === 'object' && event !== null) {
      selectedApp = event;
    } else if (Array.isArray(this.applicationData)) {
      selectedApp = this.applicationData.find(app =>
        String(app.id).trim() === String(event).trim() ||
        String(app.application_id).trim() === String(event).trim()
      );
    } else if (this.applicationData && (String(this.applicationData) === String(event))) {
      selectedApp = this.applicationData;
    }
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
   const shouldBeViewMode = this.isViewMode;
      if (shouldBeViewMode) {
        // this.sessionStorage.setItem('surrenderMode','view');
        sessionStorage.setItem('userapplicationmode', JSON.stringify('viewmode'));
      }
      // else {
      //   sessionStorage.removeItem('userapplicationmode');
      // }

  // Check if application is archived - use isApplicationArchivedForViewMode for all archived apps to be view-only
  const isApplicationArchived = this.isApplicationArchivedForViewMode(selectedApp);

  // Debug logging to trace archive status
  console.log('[DataGrid] viewApplication archive check:', {
    is_archived: selectedApp?.is_archived,
    isApplicationArchived,
    isViewMode: this.isViewMode,
    selectedApp
  });

  // Always clear applicationmode first, then set appropriately
  this.sessionStorage.removeItem('applicationmode');
  this.sessionStorage.removeItem('surrenderMode');
  this.sessionStorage.removeItem('userapplicationmode');

  if (selectedApp && (isApplicationArchived || this.isViewMode)) {
      this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
      this.sessionStorage.setItem('surrenderMode','view');
      this.sessionStorage.setItem('userapplicationmode', JSON.stringify('viewmode'));
      this.isViewMode = false;
      }


    this.sessionStorage.setItem('applicationStatus', JSON.stringify(selectedApp?.application_status ?? null));
    if (selectedApp) {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');

      const userId = user?.id || user?.user_id || user?.userId;

      if (!userId) {
        console.error(errorMessages.noValidUser);
        return;
      }

     this.myAppService
        .getApplication(selectedApp.id)
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe({
          next: personResponse => {
            const personData = personResponse.data[0];
            this.sessionStorage.setObj('personData', personData);
            this.sessionStorage.setItem('userIdForFetch',personData.user_id);

                // Check archive status from personResponse as well
                if (this.isApplicationArchivedForViewMode(personData)) {
                  this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
                  this.sessionStorage.setItem('surrenderMode', 'view');
                  this.sessionStorage.setItem('userapplicationmode', JSON.stringify('viewmode'));
                  console.log('[DataGrid] Setting view mode from personData is_archived');
                }

                let educatorName = selectedApp.educator_name ? selectedApp.educator_name : '';
                let suffix = '';
                if (personData.cd_suffix && this.suffixList && Array.isArray(this.suffixList)) {
                  const found = this.suffixList.find((s: any) => String(s.key) === String(personData.cd_suffix));
                  if (found) {
                    suffix = found.value || '';
                    personData.suffixValue = found.value; // Store suffix in personData for later use
                    this.sessionStorage.setObj('personData', personData); // Update session storage with suffix
                  }
                }
                if (suffix && suffix !== 'None') {
                  educatorName = `${educatorName} ${suffix} `;
            }

            const firstName = (personData.first_name || '').trim();
            const lastName = (personData.last_name || '').trim();
            const bannerEducatorName = `${firstName} ${lastName}`.trim();
            // let bannerheader = {};
            // if (selectedApp.application_status) {
            //   bannerheader = {
            //     'Application ID': selectedApp.application_id,
            //     'Application Type': selectedApp.application_type,
            //     'Educator Name': educatorName,
            //     'Date Submitted': this.commonService.getFormatedDate(selectedApp.date_submitted),
            //     'Application Status': selectedApp.application_status
            //   };
            // } else {
            //   bannerheader = {
            //     'Application ID': selectedApp.application_id,
            //     'Application Type': selectedApp.application_type,
            //     'Educator Name': educatorName,
            //     'Date Submitted': this.commonService.getFormatedDate(selectedApp.date_submitted)
            //   };
            // }
            const licensePathNotInclude = ['Resolve','Surrender','Name Change','License Extension']
            const submittedDateValue = selectedApp.submission_date || selectedApp.date_submitted || selectedApp.submitted_date || selectedApp.dateSubmitted;

            const bannerheader = {
                'Application ID': selectedApp.application_id,
                'Application Type': selectedApp.application_type,
                ...(selectedApp.application_type && !licensePathNotInclude.includes(selectedApp.application_type) && selectedApp.license_path !== '---' && {
                    'License Path': this.getLicensePathLabel(selectedApp.license_path)
                  }),
                'Educator Name': bannerEducatorName,
                'Submitted Date': this.commonService.getFormatedDate(submittedDateValue)
              };
              // if (selectedApp.application_status) {
              //   bannerheader['Application Status'] = selectedApp.application_status;
              // }
              if (selectedApp.re_submitted_date && selectedApp.re_submitted_date != '---') {
                bannerheader['Resubmitted Date'] = this.commonService.getFormatedDate(selectedApp.re_submitted_date);
              }

              if(selectedApp.application_type == 'Surrender'){

                this.sessionStorage.setItem('surrender', 'analystSurrender');
                this.sessionStorage.setItem('applicationStatus',selectedApp.application_status);
              }

              const licBanner = this.commonService.resolveLicenseNumberForBanner(
                selectedApp as Record<string, unknown>
              );
              if (licBanner) {
                bannerheader['License Number'] = licBanner;
              }

            const inputFormatForAppData = { bannerheader };
            this.sessionStorage.setObj('navigationData', inputFormatForAppData);
            this.myAppService
              .getAppData(`appId=${selectedApp.id}`)
              .pipe(take(1), takeUntil(this.destroy$))
              .subscribe({
                next: appResponse => {
                  const appData = appResponse.data.data[0];
                  const { activeversionid,  license_path, cd_application_type, resolve_base_application_type, extend_base_application_type } = appResponse.data.data[0];

                  // Re-check archive status from API response data (more reliable than grid data)
                  // This catches cases where is_archived wasn't in the grid row data
                  const isArchivedFromApi = this.isApplicationArchivedForViewMode(appData) || this.isApplicationArchivedForViewMode(selectedApp);
                  console.log('[DataGrid] API response archive check:', {
                    appData_is_archived: appData?.is_archived,
                    selectedApp_is_archived: selectedApp?.is_archived,
                    isArchivedFromApi
                  });

                  if (isArchivedFromApi) {
                    this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
                    this.sessionStorage.setItem('surrenderMode', 'view');
                    this.sessionStorage.setItem('userapplicationmode', JSON.stringify('viewmode'));
                    console.log('[DataGrid] Setting view mode for archived application');
                  }

                  // Set cd_license_type in session storage from API response (DB value)
                  const licenseTypeFromApi = appData.alm_cd_license_type;
                  if (licenseTypeFromApi && licenseTypeFromApi !== '---') {
                    this.sessionStorage.setItem('cd_license_type', licenseTypeFromApi.toString());
                    console.log('[DATA GRID] Stored cd_license_type in session from API:', licenseTypeFromApi);
                  }

                  // Set licenseIssueDate in session storage from API response (DB value)
                  const licenseIssueDateFromApi = appData.alm_license_issue_date;
                  if (licenseIssueDateFromApi) {
                    const issueDate = new Date(licenseIssueDateFromApi);
                    if (!isNaN(issueDate.getTime())) {
                      const month = (issueDate.getMonth() + 1).toString().padStart(2, '0');
                      const day = issueDate.getDate().toString().padStart(2, '0');
                      const year = issueDate.getFullYear();
                      this.sessionStorage.setItem('licenseIssueDate', `${month}/${day}/${year}`);
                      console.log('[DATA GRID] Stored licenseIssueDate in session from API:', `${month}/${day}/${year}`);
                    }
                  }

                  // Store RCR-related fields in session storage ONLY for RCR applications (when license_path exists)
                  // Skip license-path session for Resolve (same as application dashboard)
                  this.activeversionid = selectedApp.application_type == 'Surrender'? this.sessionStorage.getItem('surrenderActiveversionid') : activeversionid;
                  if (license_path !== null && license_path !== undefined && selectedApp.application_type !== 'Resolve') {
                    this.sessionStorage.setItem('license-application-type', cd_application_type.toString());
                    // Clean license_path value to ensure it's stored as plain string without quotes
                    const cleanLicensePath = typeof license_path === 'string' ? license_path.replace(/"/g, '') : license_path.toString();
                    this.sessionStorage.setItem('license-path', cleanLicensePath);
                    console.log('[OPEN APP] RCR application - Stored license-application-type:', cd_application_type, 'license-path:', cleanLicensePath);
                  } else {
                    console.log('[OPEN APP] Non-RCR application or Resolve - Skipping license-path session storage');
                  }

                  // Store resolve_base_application_type for Resolve applications
                  if (resolve_base_application_type !== null && resolve_base_application_type !== undefined) {
                    let resolveBaseAppTypeValue = resolve_base_application_type;
                    if (this.applicationtypes?.length > 0) {
                      const matchedType = this.applicationtypes.find(type => String(type.key) === String(resolve_base_application_type));
                      resolveBaseAppTypeValue = matchedType ? matchedType.value : resolve_base_application_type;
                    }
                    this.sessionStorage.setItem('resolve_base_application_type', JSON.stringify(resolveBaseAppTypeValue));
                    console.log('[OPEN APP] Stored resolve_base_application_type:', resolveBaseAppTypeValue);
                  }

                  // Store extend_base_application_type for License Extension applications
                  if (extend_base_application_type !== null && extend_base_application_type !== undefined) {
                    let extendBaseAppTypeValue = extend_base_application_type;
                    if (this.applicationtypes?.length > 0) {
                      const matchedExtendType = this.applicationtypes.find(type => String(type.key) === String(extend_base_application_type));
                      extendBaseAppTypeValue = matchedExtendType ? matchedExtendType.value : extend_base_application_type;
                    }
                    this.sessionStorage.setItem('extend_base_application_type', JSON.stringify(extendBaseAppTypeValue));
                    console.log('[OPEN APP] Stored extend_base_application_type:', extendBaseAppTypeValue);
                  }

                  if (this.activeversionid) {
                    const closeTargets = this.getApplicationCloseSessionTargets();
                    this.sessionStorage.setItem('youthID', JSON.stringify(selectedApp.id || event));
                    this.sessionStorage.setItem('youthNumber', JSON.stringify(selectedApp.application_number ?? selectedApp.application_id ?? selectedApp.id));
                    this.sessionStorage.setItem('applicationID', JSON.stringify(selectedApp.id));
                    this.sessionStorage.setItem('isFirstSave', 'false');
                    this.sessionStorage.setItem('applicationType', JSON.stringify(selectedApp.application_type));
                    this.sessionStorage.setItem('currApplicationType', JSON.stringify(selectedApp.application_type));
                    this.sessionStorage.setItem('backToHome', JSON.stringify(closeTargets.backToHome));
                    this.sessionStorage.setItem('backButtonText', 'Close');
                    this.sessionStorage.setItem('backToGridPage', JSON.stringify(closeTargets.backToGridPage));
                    this.fetchAndSetApplicationFee(license_path);
                    const sessionData: AssignmentSessionData = {
                      youthID: selectedApp.id || event,
                      youthNumber: selectedApp.application_number ?? selectedApp.application_id ?? selectedApp.id,
                      applicationID: selectedApp.id,
                      isFirstSave: 'false',
                      applicationType: selectedApp.application_type,
                      currApplicationType: selectedApp.application_type,
                      backToHome: closeTargets.backToHome,
                      backToGridPage: closeTargets.backToGridPage,
                      applicationTotalFee: 0,
                      applicationFee: 0
                    };

                    Object.entries(sessionData).forEach(([key, value]) => {
                      this.sessionStorage.setItem(key, JSON.stringify(value));
                    });
                    this.router.navigate([`/pages/dynamic-routing/tab/${this.activeversionid}`]);
                  } else {
                    console.error(errorMessages.noActiveVersionId);
                  }
                },
                error: error => {
                  console.error('Error getting app data:', error);
                }
              });
          },
          error: error => {
            console.error('Error getting person data:', error);
          }
        });
    } else {
      console.error('Application not found:', event);
    }
  }
  tempLockQueue(rowData: any) {
    if (!rowData) {
      return;
    }
    const user = this.commonService.getCurrentUserData();
    const userId = user?.id || user?.user_id || user?.userId;
    if (!userId) {
      return;
    }
    const payload = {
      userId: userId,
      applicationNumber: rowData.id,
      lockStatus: LOCK_STATUS_CODES.TEMP_LOCKED
    };
    this.httpService
      .post(API_ENDPOINTS.TEMP_LOCK_QUEUE_APPLICATION, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (_response: any) => { },
        error: _error => {
          this.alertService.error('Failed to temp lock application. Please try again later.');
        }
      });
  }

  private getModalConfig(userRoleId: number, lockStatus: string | null): ModalConfig | null {
    const isUnlocked =
      lockStatus === LOCK_STATUS_CODES.UNLOCKED ||
      lockStatus === LOCK_STATUS_CODES.TEMP_LOCKED ||
      lockStatus === null ||
      lockStatus === '---' ||
      lockStatus === undefined;

    if ((userRoleId === ROLE_ID.NDE_Analyst || userRoleId === ROLE_ID.Licensing_Analyst)  && isUnlocked) {
      return {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.assign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.assignApp,
        modalContent: modalContent.assignAppToYourself,
        hasTemplate: true
      };
    }


    if ((userRoleId === ROLE_ID.NDE_Administrator || userRoleId === ROLE_ID.NDE_LeadAnalyst || userRoleId === ROLE_ID.Licensing_LeadAnalyst) && isUnlocked) {
      const dropdownOptions = this.personsByRole.map(person => ({
        label: person.full_name,
        value: person.id || person.user_id || person.userId || person.person_id
      }));

      return {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.assign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.assignApp,
        modalContent: modalContent.assignAppToStaffMember(),
        hasTemplate: true,
        hasDropdown: true,
        dropdownLabel: 'Assign To',
        dropdownOptions: dropdownOptions,
        dynamicContent: true
      };
    } else {
      return {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.unassign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.unassignApp,
        modalContent: modalContent.unassignApp,
        hasTemplate: true
      };
    }
  }

  toggleAssignDialog(record) {
    const userObj = this.commonService.getCurrentUserData();
    if (!userObj) return;
    this.currentRoleId = userObj?.userroles[0].id || null;
    if (!this.currentRoleId) return;

    const userRoleId = Number(this.currentRoleId);
    const isAuthorized =
      userRoleId === ROLE_ID.NDE_Analyst || userRoleId === ROLE_ID.Licensing_Analyst ||
      userRoleId === ROLE_ID.NDE_Administrator ||
      userRoleId === ROLE_ID.NDE_LeadAnalyst || userRoleId === ROLE_ID.Licensing_LeadAnalyst;

    if (!isAuthorized) return;

    const modalConfig = this.getModalConfig(userRoleId, record.lockstatus);
    if (!modalConfig) return;

    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md'
    };

this.customModal = this.ngbService.open(ModalComponent, options);
    this.customModal.componentInstance.modalConfig = modalConfig;
    this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
      // Force close modal immediately when any button is clicked
      this.ngbService.dismissAll();

      if (!response || !response.confirmed) {
        // User clicked cancel
        return;
      }

      const isUnlocked =
        record.lockstatus === LOCK_STATUS_CODES.UNLOCKED ||
        record.lockstatus === null ||
        record.lockstatus === undefined ||
        record.lockstatus === '---';
      const isAdminOrLead = userRoleId === ROLE_ID.NDE_Administrator || userRoleId === ROLE_ID.NDE_LeadAnalyst || userRoleId === ROLE_ID.Licensing_LeadAnalyst;

      if (isUnlocked && isAdminOrLead) {
        this.assign.emit({ record, 'assign': true, selectedStaffMemberId: response.selectedStaffMember, personsByRole: this.personsByRole });
      } else if (isUnlocked && (userRoleId === ROLE_ID.NDE_Analyst || userRoleId === ROLE_ID.Licensing_Analyst) && LOCK_STATUS_CODES.UNLOCKED) {
        this.assign.emit({ record, 'assign': true });
      } else if (!isUnlocked) {
        this.assign.emit({ record, 'assign': false });
      }
    });
  }

  // Method to close the assign modal programmatically (call after API success)
  closeAssignModal(): void {
    if (this.customModal) {
      this.customModal.close();
      this.customModal = null;
    }
    // Fallback: dismiss all open modals
    this.ngbService.dismissAll();
  }

  getFilteredDataFromGrid(): any[] {
    if (!this.dataGrid || !this.dataGrid.instance) {
      return this.applicationData || this.config.data || [];
    }

    try {
      const dataSource = this.dataGrid.instance.getDataSource();

      if (!dataSource) {
        return this.applicationData || this.config.data || [];
      }

      if (dataSource.items && typeof dataSource.items === 'function') {
        const dataSourceItems = dataSource.items();
        if (Array.isArray(dataSourceItems)) {
          return dataSourceItems;
        }
      }

      return this.applicationData || this.config.data || [];
    } catch (error) {
      return this.applicationData || this.config.data || [];
    }
  }

  exportFilteredDataToExcel(columns: any[], fileName: string): void {
    const filteredData = this.getFilteredDataFromGrid();

    if (!filteredData || filteredData.length === 0) {
      this.alertService.warn('No data to export');
      return;
    }

    if (!columns || columns.length === 0) {
      this.alertService.warn('No columns selected for export');
      return;
    }

    const exportRows = filteredData.map(row => ({
      ...row,
      application_type: this.getApplicationTypeCellDisplayValue(row)
    }));
    this.commonService.exportToExcel(exportRows, columns, fileName);
  }

  downloadRowPDF(data: any) {
    if (!data || !data.id) {
      return;
    }
    this.rowDownloadDialogData = null;

    this.isGeneratingPDF = true;
    this.loaderService.show();

    const loaderInterval: number = window.setInterval(() => {
      if (this.isGeneratingPDF) {
        this.loaderService.show();
      } else {
        window.clearInterval(loaderInterval);
      }
    }, 100);

    setTimeout(() => {
      const selectedApp = this.applicationData.find(app => app.application_id === data.application_id);
      if (!selectedApp) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
      const applicationId = selectedApp.id || data.id;

      if (!applicationId) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
      this.commonService.PDFGenerate(applicationId);
    }, 100);
      this.isGeneratingPDF = false;
      this.loaderService.hide();
  }



  // Helper method for getting cell template based on data field
  getCellTemplate(dataField: string): string | undefined {
    if (dataField === this.statusDataField || dataField === DATA_FIELDS.COMPLAINT_STATUS) return CELL_TEMPLATES.STATUS;
    if (dataField === 'archival_status') return CELL_TEMPLATES.STATUS;
    if (dataField === 'archive') return CELL_TEMPLATES.STATUS;
    if (dataField === 'complaint_archival_status') return CELL_TEMPLATES.STATUS;
    if (dataField === 'State') return CELL_TEMPLATES.STATUS;
    if (dataField === DATA_FIELDS.CD_APPLICATION_TYPE) return CELL_TEMPLATES.TYPE;
    if (dataField === 'endorsementStatus') return CELL_TEMPLATES.STATUS;
    if (dataField === 'extensionStatus') return CELL_TEMPLATES.EXTENSION_STATUS;
    if (dataField === 'endorsementGrade') return CELL_TEMPLATES.ENDORSEMENT_GRADE;
    if (dataField === DATA_FIELDS.APPLICATION_ID || dataField === DATA_FIELDS.APPLICATION_NUMBER) {
      return CELL_TEMPLATES.APP_ID;
    }
    if (dataField === DATA_FIELDS.CASE_ID) return CELL_TEMPLATES.CASE_ID;
    if (dataField === DATA_FIELDS.EDUCATOR_NAME) {
      if (this.config?.plainTextEducatorName) return undefined;
      return CELL_TEMPLATES.EDUCATOR_NAME;
    }
    if (dataField === DATA_FIELDS.LOCKED_BY || dataField === DATA_FIELDS.LOCKED_BY_CAPITAL)
      return CELL_TEMPLATES.LOCKED_BY;
    if (dataField === 'complaint_form_id') return CELL_TEMPLATES.COMPLAINT_FORM_ID;
    if (dataField === 'Value') return 'Value';
    if (dataField === 'queuesvalue') return 'queuesvalue';
    if (dataField === 'securityvalue') return 'securityvalue';
    if (dataField === 'registrationvalue') return 'registrationvalue';
    if (dataField === 'background_check_status' || dataField === 'bg1_status' || dataField === 'bg2_status') return 'backgroundStatusValue';
    if (dataField === 'template_status') return 'activeBadgeTemplate';
    if (dataField === 'subject') return 'emailSubjectTemplate';
    if (dataField === 'status') return 'emailStatusTemplate';
    if (dataField === 'additionalText') return 'additionalTextTooltipTemplate';
    if (dataField === 'cd_transaction_status') return 'transactionStatusTemplate';
    if (dataField === 'transcript_status') return 'transcriptStatusTemplate';
    return undefined;
  }

  viewNotes(data: any) {
    this.customAction.emit({ action: 'viewNotes', data });
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'xl',
      windowClass: 'internal-notes-modal-window'
    };
    const modalRef = this.ngbService.open(InternalNotesModalComponent, options);
    const applicationId = data?.application_id ?? '';
    console.log('Viewing notes for applicationId:', applicationId);
    console.log('Viewing notes for applicationId:', data);
    const idForName = applicationId || data?.complaint_form_id || data?.id || '';
    modalRef.componentInstance.title = 'Internal Notes';
    modalRef.componentInstance.exportFileName = idForName
      ? `Internal Notes - ${idForName}`
      : 'Internal Notes';

    // Pass the actual active tab name through as tabName.
    // (Previously admin/analyst/intake/deficiency/doesNotQualify were all mapped to
    // 'case management', which is incorrect — only send 'case management' when actually
    // on a case management tab.)
    const tabName: string = this.activeTab ? String(this.activeTab).trim() : '';

    if (tabName && applicationId) {
      const payload = { tabName, applicationId };
      // Section field source:
      //   background or case-management tabs -> response field `cd_section`
      //   any other tab                      -> response field `section_code`
      const caseManagementTabs = ['admin', 'analyst', 'intake', 'deficiency', 'doesNotQualify'];
      const useCdSection = tabName === 'background' || caseManagementTabs.includes(tabName);
      this.httpService.post(API_ENDPOINTS.INTERNAL_NOTES_QUEUES, payload)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            const rawList = response?.data?.data || response?.data || [];
            // Debug: confirm what field names the backend actually returns.
            if (Array.isArray(rawList) && rawList.length) {
              console.log('[InternalNotes][data-grid] raw item keys:', Object.keys(rawList[0]), rawList[0]);
            }
            const pickSection = (item: any) => {
              const primary = useCdSection ? item?.cd_section : item?.section_code;
              const fallback = useCdSection ? item?.section_code : item?.cd_section;
              return primary ?? fallback ?? item?.section ?? item?.section_name ?? '';
            };
            const pickUpdatedDate = (item: any) =>
              item?.updated_date ?? item?.updated_at ?? item?.updated_on ?? item?.modified_date
              ?? item?.modified_at ?? item?.last_updated ?? item?.last_updated_date
              ?? item?.created_date ?? item?.created_at ?? '';
            const mapped = Array.isArray(rawList)
              ? rawList.map((item: any) => ({
                  section: pickSection(item),
                  notes: item?.note_text ?? item?.notes ?? '',
                  added_by: (item?.created_by_name && String(item.created_by_name).trim())
                    || (item?.added_by && String(item.added_by).trim())
                    || (item?.created_by != null ? String(item.created_by) : ''),
                  updated_date: pickUpdatedDate(item)
                }))
              : [];
            modalRef.componentInstance.notes = mapped;
          },
          error: () => {
            modalRef.componentInstance.notes = [];
          }
        });
    } else {
      modalRef.componentInstance.notes = Array.isArray(data?.internal_notes) ? data.internal_notes : [];
    }
  }

  unArchive(data:any){
    if(this.isAdmin){
      const modalConfig = {
        buttons: [
            { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
            { text: modalButtonTitles.proceed, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
          ],
          heading: modalHeading.unarchiveApplication,
          modalContent: modalContent.unArchiveApplication,
          hasTemplate: true
        }
      const options: NgbModalOptions = {
        backdrop: 'static',
        centered: true,
        size: 'md'
      };
      this.customModal = this.ngbService.open(ModalComponent, options);
      this.customModal.componentInstance.modalConfig = modalConfig;
      this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
        const payload = {
              userId: this.getCurrentUserIdForMessages(),
              application_id: data.id,
              application_status : data.application_status,
            };
        if(response.confirmed){
          this.myAppService.unArchiveApplication(payload).pipe(take(1),takeUntil(this.destroy$))
          .subscribe({
            next:(res:any)=>{
              if(res.data.success == true){
                this.unArchivalChange.emit();
              }
            }
          })
        }
      });
    }

  }

  /** Matches Lookup Activities deriveArchivalStatus "Archived" branch — show archive icon only when archived. */
  // isArchivedForAppIdIcon(row: { is_archived?: unknown } | null | undefined): boolean {
  //   const v = row?.is_archived;
  //   if (v === true || v === 1 || v === '1') return true;
  //   if (typeof v === 'string') {
  //     const s = v.trim().toLowerCase();
  //     if (s === 'true' || s === 't') return true;
  //   }
  //   return false;
  // }

    /** Show archive icon when the row is flagged archived and its archival timestamp (date + time) is in the past. */
    isArchivedForAppIdIcon(row: { is_archived?: unknown; archival_date?: unknown; archivedatetime? : unknown } | null | undefined): boolean {
      const archivalRaw = row?.archivedatetime;
      if (archivalRaw != null && archivalRaw !== '' && archivalRaw !== '---') {
        // Normalize "YYYY-MM-DD HH:mm:ss.ffffff+TZ" to ISO 8601 so the time and timezone parse reliably.
        const normalized = typeof archivalRaw === 'string' ? archivalRaw.trim().replace(' ', 'T') : archivalRaw;
        const archivalDate = new Date(normalized as string | number | Date);
        if (!Number.isNaN(archivalDate.getTime())) {
          // Compare full instants (date + time), not just the calendar date.
          if (row?.is_archived && archivalDate.getTime() < Date.now()) return true;
        }
      }

      return false;
    }

  /**
   * Check if application is archived for view-mode purposes.
   * Returns true if:
   * 1. is_archived is truthy in any format (true, 1, "1", "true", "t"), OR
   * 2. archival_date exists and is in the past (archival_date < today)
   * This is used to determine if the application should open in view-only mode.
   */
  isApplicationArchivedForViewMode(row: { is_archived?: unknown; archival_date?: unknown } | null | undefined): boolean {
    if (!row) return false;

    // Check is_archived flag first
    const v = row.is_archived;
    if (v === true || v === 1 || v === '1') return true;
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      if (s === 'true' || s === 't' || s === 'yes' || s === 'y') return true;
    }

    // Check archival_date - if it exists and is in the past, application is archived
    const archivalRaw = row.archival_date;
    if (archivalRaw != null && archivalRaw !== '' && archivalRaw !== '---') {
      let archivalDate: Date | null = null;

      if (typeof archivalRaw === 'string') {
        // Try parsing MM/DD/YYYY format first
        const parts = archivalRaw.split('/');
        if (parts.length === 3) {
          const month = parseInt(parts[0], 10);
          const day = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          archivalDate = new Date(year, month - 1, day);
        } else {
          // Try standard date parsing
          archivalDate = new Date(archivalRaw);
        }
      } else if (archivalRaw instanceof Date) {
        archivalDate = archivalRaw;
      } else {
        archivalDate = new Date(archivalRaw as string | number);
      }

      if (archivalDate && !Number.isNaN(archivalDate.getTime())) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        archivalDate.setHours(0, 0, 0, 0);

        // If archival date has passed, application is archived
        if (archivalDate < today) {
          console.log('[DataGrid] Application archived based on archival_date:', archivalRaw, 'parsed as:', archivalDate);
          return true;
        }
      }
    }

    return false;
  }

  isExtensionStatusEligible(status: any): boolean {
    return String(status ?? '').trim().toLowerCase() === 'eligible';
  }

 isExtensionStatusIneligible(status: any): boolean {
    const normalized = String(status ?? '').trim().toLowerCase();
    return normalized === 'ineligible' || normalized === 'not eligible';
  }

  getStatusColorClass(status: string): string {
    if (this.statusColorOverrides && status) {
      const normalizedStatus = status.trim().toLowerCase();
      if (this.statusColorOverrides[normalizedStatus]) {
        return this.statusColorOverrides[normalizedStatus];
      }
    }
    return resolveStatusColor(status);
  }

  getBgStatusColorClass(status: string): string {
    return resolveBgStatusColor(status);
  }

  getTranscriptStatusClass(status: string): string {
    switch (String(status ?? '').trim().toLowerCase()) {
      case 'pending': return 'transcript-status-pending';
      case 'received': return 'transcript-status-received';
      default: return 'transcript-status-default';
    }
  }

  // Convenient getters for template usage
  /**
   * Enables dxo-column-fixing when the Actions column is shown (right-fixed) or any custom header
   * sets fixed (e.g. left-pinned columns on specific grids).
   */
  get hasColumnFixing(): boolean {
    if (this.config?.showActionsColumn) return true;
    const headers = this.config?.customHeaders;
    return Array.isArray(headers) && headers.some((h: { fixed?: boolean }) => h?.fixed === true);
  }
  get customHeaders() {
    return this.config.customHeaders;
  }
  get showActionsColumn() {
    return this.config.showActionsColumn;
  }
  get showFiltering() {
    return this.config.showFiltering;
  }
  get showSearchRow() {
    return this.config.showSearchRow;
  }
  get showPaging() {
    return this.config.showPaging;
  }
  get customPageSize() {
    return this.config.customPageSize;
  }
  get customPageSizes() {
    return this.config.customPageSizes;
  }
  get customNoDataText() {
    return this.config.customNoDataText;
  }
  get customAriaLabel() {
    return this.config.customAriaLabel;
  }
  get showQueueActions() {
    return this.config.showQueueActions;
  }
  get disableApplicationClick() {
    return this.config.disableApplicationClick;
  }
  get customActionTemplate() {
    return this.config.customActionTemplate;
  }
  get showNewDocumentIcon() {
    return this.config.showNewDocumentIcon;
  }
  get showNewUploadIcon() {
    return this.config.showNewUploadIcon;
  }
  get showStaffUpdateIcon() {
    return this.config.showStaffUpdateIcon;
  }
  // get showNewApplicantUpdateIcon() {
  //   return this.config.showNewApplicantUpdateIcon;
  // }
  get showPaymentCompletedIcon() {
    return this.config.showPaymentCompletedIcon;
  }
  get showPaymentPendingIcon() {
    return this.showPaymentPendingIconFlag || !!this.config?.showPaymentPendingIcon;
  }
  get data() {
    if (this.applicationData && this.applicationData.length > 0) {
      return this.applicationData;
    }
    return this.config.data;
  }
  get visibleColumns() {
    return this.config.visibleColumns;
  }
  get role() {
    return this.config.role;
  }
  /** Lookup-search: all users who reach the page may open educator detail; do not gate on queue applicationId rules. */
  get isEducatorNameClickable(): boolean {
    if (this.role === 'lookup-search') {
      return true;
    }
    return this.applicationIdClickable;
  }

  /** True when the row has both an internal id (navigation target) and a displayable application number. */
  hasApplicationLink(row: { id?: unknown; application_id?: unknown } | null | undefined): boolean {
    if (!row) return false;
    const internalId = row.id != null && String(row.id).trim() !== '' && String(row.id).trim() !== '---';
    const appNumber =
      row.application_id != null &&
      String(row.application_id).trim() !== '' &&
      String(row.application_id).trim() !== '---';
    return internalId && appNumber;
  }
  get configActiveTab() {
    return this.config.activeTab;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.rowDownloadDialogData) {
      return;
    }
    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }

    const downloadPopover = target.closest('.download-popover-container');
    const downloadButton = target.closest('.download-wrapper');
    if (!downloadPopover && !downloadButton) {
      this.rowDownloadDialogData = null;
    }
  }

  onValueInputChange(cell: any, event: any) {
    const newValue = event.target.value;
    // Only allow numbers
    if (/^\d*$/.test(newValue)) {
      cell.data.Value = newValue;
      cell.data.intValue = newValue === '' ? null : Number(newValue);
      // Show error if empty
      cell.data.valueError = newValue === '';
    } else {
      cell.data.valueError = true;
    }
    this.rowChanged.emit(cell.data);
  }
    onQueuesValueInputChange(cell: any, event: any) {
      const newValue = event.target.value;
      if (/^\d*$/.test(newValue)) {
        cell.data.queuesvalue = newValue;
        cell.data.queuesValueError = newValue === '';
      } else {
        cell.data.queuesValueError = true;
      }
      this.rowChanged.emit(cell.data);
    }

    onSecurityValueInputChange(cell: any, event: any) {
      const newValue = event.target.value;
      if (/^\d*$/.test(newValue)) {
        cell.data.securityvalue = newValue;
        cell.data.securityValueError = newValue === '';
      } else {
        cell.data.securityValueError = true;
      }
      this.rowChanged.emit(cell.data);
    }

    onRegistrationValueInputChange(cell: any, event: any) {
      const newValue = event.target.value;
      if (/^\d*$/.test(newValue)) {
        cell.data.registrationvalue = newValue;
        cell.data.registrationValueError = newValue === '';
      } else {
        cell.data.registrationValueError = true;
      }
      this.rowChanged.emit(cell.data);
    }

  private fetchAndSetApplicationFee(licensePath: string): void {
    this.httpService.get('/domain/lookup?requestType=FEE_CATEGORY').pipe(take(1)).subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        const feeKeyMap: Record<string, string> = { '1': '2', '2': '7', '3': '1', '4': '8' };
        const feeKey = feeKeyMap[licensePath] || '1';
        const feeRow = data.find((item: any) => String(item.key) === feeKey);
        if (feeRow) {
          const opt = typeof feeRow.optionaldata === 'string' ? JSON.parse(feeRow.optionaldata) : feeRow.optionaldata;
          const baseFee = Number(opt?.fee) || 0;
          this.sessionStorage.setItem('applicationTotalFee', JSON.stringify(baseFee));
          this.sessionStorage.setItem('applicationFee', JSON.stringify(baseFee));
        }
        const bgCheckRow = data.find((item: any) => String(item.key) === '6');
        if (bgCheckRow) {
          const bgOpt = typeof bgCheckRow.optionaldata === 'string' ? JSON.parse(bgCheckRow.optionaldata) : bgCheckRow.optionaldata;
          this.sessionStorage.setItem('backgroundCheckFee', JSON.stringify(Number(bgOpt?.fee) || 0));
        }
        const hasApprovedExtension = JSON.parse(this.sessionStorage.getItem('has_approved_extension') || 'false');
        if (licensePath === '1' && hasApprovedExtension) {
          const extRow = data.find((item: any) => String(item.key) === '4');
          if (extRow) {
            const extOpt = typeof extRow.optionaldata === 'string' ? JSON.parse(extRow.optionaldata) : extRow.optionaldata;
            this.sessionStorage.setItem('extensionFee', JSON.stringify(Number(extOpt?.fee) || 0));
          }
        }
      }
    });
  }
  getEducatorDisplayText(educatorName: string | null | undefined): string {
  if (educatorName === '---') {
    return 'Not Validated';
  }

  const educators = educatorName.split(',').map(e => e.trim());

  if (educators.length === 1) {
    return educators[0];
  }

  return `${educators[0]} +${educators.length - 1}`;
}

getEducatorTooltip(educatorName: string | null | undefined): string | null {
  if (educatorName === '---') {
    return null;
  }

  return educatorName;
}
@HostListener('window:resize')
onResize() {
  this.checkScreen();
}
checkScreen() {
  this.responsiveisMobileView = window.innerWidth <= 1024;
}
   
  // Handle page index change
  onPageIndexChanged(event: any) {
    this.currentPage = event.pageIndex + 1; // Page index starts from 0, adjust to match your server-side logic
    this.loadPageData();
  }
onPageSizeChanged(event: any) {
    this.pageSize = event.pageSize;
    this.loadPageData();
  }

//   private isDateColumnByConfig(dataField: string): boolean {
//   if (!dataField) return false;
//   const allHeaders = this.config?.customHeaders?.length > 0
//     ? this.config.customHeaders
//     : this.headers;
//   if (!Array.isArray(allHeaders)) return false;
//   const matchedHeader = allHeaders.find((h: any) => h?.dataField === dataField);
//   if (!matchedHeader) return false;
//   return (
//     matchedHeader.dataType === 'date' ||
//     matchedHeader?.allowSearch?.type === 'date'
//   );
// }

  private getCurrentUserIdForMessages(): number | null {
    try {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
      const id = user?.id ?? user?.userId ?? user?.user_id ?? this.sessionStorage.getItem('id');
      if (id == null) return null;
      const num = typeof id === 'number' ? id : parseInt(String(id), 10);
      return isNaN(num) ? null : num;
    } catch {
      return null;
    }
  }

  loadUnreadMessageCount(data: any[]): void {
    const userId = this.getCurrentUserIdForMessages();
    if (userId == null) return;

    const entityIds: number[] = [];

    // From passed data
    if (Array.isArray(data)) {
      data.forEach((app: any) => {
        const id = Number(app.id ?? app.application_id);
        if (!isNaN(id) && !entityIds.includes(id)) {
          entityIds.push(id);
        }
      });
    }

    if (entityIds.length === 0) {
      this.unreadCountByApplicationId = {};
      return;
    }

    this.inAppMessageService
      .getUnreadCountsForMultipleEntities(entityIds, userId)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const body = res?.body ?? res;
          const dataArr = Array.isArray(body?.data?.data)
            ? body.data.data
            : Array.isArray(body?.data)
              ? body.data
              : Array.isArray(body)
                ? body
                : [];

          const byId: Record<number, number> = {};

          dataArr.forEach((row: any) => {
            const entityId = Number(row?.message_entity_id);
            if (!isNaN(entityId)) {
              byId[entityId] = Number(row?.count) || 0;
            }
          });

          this.unreadCountByApplicationId = byId;
        },
        error: () => {
          this.unreadCountByApplicationId = {};
        }
      });
  }

  private extractArrayFromPagedData(pagedata: any): any[] {
    if (Array.isArray(pagedata)) {
      return pagedata;
    }

    if (Array.isArray(pagedata?.data)) {
      return pagedata.data;
    }

    return [];
  }

   hasEndorsementOverflow(endorsementGradeArray: any[]): boolean {
    return Array.isArray(endorsementGradeArray) && endorsementGradeArray.length > 2;
  }

  getEndorsementGradeDisplayText(endorsementGradeArray: any[]): string {
    if (!Array.isArray(endorsementGradeArray) || endorsementGradeArray.length === 0) {
      return '---';
    }

    // Display first 2 items
    const displayItems = endorsementGradeArray.slice(0, 2).map((item: string) => item.trim()).join(', ');

    // If more than 2 items, add "+N more" indicator
    if (endorsementGradeArray.length > 2) {
      const moreCount = endorsementGradeArray.length - 2;
      return `${displayItems}, +${moreCount} more`;
    }

    return displayItems;
  }

  getEndorsementGradeTooltip(endorsementGradeArray: any[]): string {
    if (!Array.isArray(endorsementGradeArray) || endorsementGradeArray.length === 0) {
      return '';
    }

    // Return all items for tooltip, showing those beyond the first 2
    const hiddenItems = endorsementGradeArray.slice(2).map((item: string) => item.trim());
    return hiddenItems.join(', ');
}

  getUnreadMessageCount(rowData: any): number {
    const rowCount = Number(rowData?.count);
    if (!isNaN(rowCount) && rowCount > 0) {
      return rowCount;
    }

    const entityId = Number(rowData?.id ?? rowData?.application_id);
    if (isNaN(entityId)) {
      return 0;
    }

    return Number(this.unreadCountByApplicationId[entityId]) || 0;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.rowDownloadDialogData = null;
  }
}
